export default "__VITE_ASSET__9eac8619__"